import { getExternalConnectionsQuery } from '@griply/services';
import { collection, getFirestore, query, where } from 'firebase/firestore';

import { externalConnectionsConverter } from './converters/external-connections';
import { getAuthentication } from './helpers';

export const getExternalCalendarConnectionsQuery = async () => {
  const auth = await getAuthentication();

  return getExternalConnectionsQuery({
    db: getFirestore(),
    collection,
    query,
    where,
    userId: auth.currentUser?.uid ?? '',
  }).withConverter(externalConnectionsConverter);
};
